import React from 'react'
import { connect } from 'react-redux'
import '../css/styles.css';

class MainImportantBullets extends React.Component {

    render() {
        return (
            <ul>
                <li>{this.props.strings.INFO_POINT_1}</li>
                <li>{this.props.strings.INFO_POINT_2}</li>
                <li>{this.props.strings.INFO_POINT_3}</li>
                <li>{this.props.strings.INFO_POINT_4}</li>
                <li>{this.props.strings.INFO_POINT_5}</li>
                <li>{this.props.strings.INFO_POINT_6}</li>
                <li>{this.props.strings.INFO_POINT_7}</li>
                <li>{this.props.strings.INFO_POINT_8}</li>
            </ul>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
    }
}

const ConnectedMainImportantBullets = connect(
    mapStateToProps
)(MainImportantBullets);
export default ConnectedMainImportantBullets;
